import React, { useEffect, useState } from 'react'
import lodash from 'lodash'
import { Formik, Form, Field } from 'formik'
import { Box } from '@material-ui/core'
import { navigate } from '@reach/router'

import CustomInput from '../../Custom/CustomInput'
import {
  signupInitialValues,
  signupValidationSchema,
  validateConfirmPassword
} from '../../../forms/Signup'
import PrimaryButtton from '../../Custom/Button/PrimaryButtton'
import {
  firebaseFetchOneSignupInfo,
  firebaseCreateUser,
  firebaseCreateNewUser
} from '../../../firebase/auth'

export default function AuthSignupForm(props) {
  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [signupInfo, setSignupInfo] = useState(null)

  /**
  |--------------------------------------------------
  | Prepate Values
  |--------------------------------------------------
  */
  useEffect(() => {
    async function fetchSignupInfo() {
      try {
        const info = await firebaseFetchOneSignupInfo(props.signupToken)

        if (info.isExpired) {
          navigate(`/`)
        }

        setSignupInfo(info)
      } catch (error) {
        console.error(error)
      }
    }

    fetchSignupInfo()
  }, [props.signupToken])

  /**
  |--------------------------------------------------
  | Signup
  |--------------------------------------------------
  */
  async function signup(values) {
    try {
      const { user } = await firebaseCreateUser(signupInfo.email, values.password)

      const newUser = {
        email: signupInfo.email,
        dealer: signupInfo.dealerID,
        factory: lodash.get(signupInfo, 'factoryID', null),
        role: signupInfo.role
      }

      await firebaseCreateNewUser(user.uid, newUser)
      navigate('/')
    } catch (error) {
      console.error(error)
    }
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <Formik
      initialValues={signupInitialValues()}
      onSubmit={signup}
      validationSchema={signupValidationSchema}
    >
      {formikProps => (
        <Form>
          <div className="w-screen h-screen flex justify-center items-center">
            <div className="w-full mx-2 md:mx-0 md:w-1/2">
              <Box width="100%" bgcolor="grey.800" p={3} borderRadius="borderRadius">
                <div className="flex flex-col justify-center items-center">
                  {/* PASSWORD ──────────────────────────────────────────────────────────────────────────────── */}
                  <div className="w-full flex">
                    <p className="w-1/3 text-base">Password</p>
                    <div className="w-2/3">
                      <Field name="password">
                        {({ field, meta }) => (
                          <CustomInput
                            fullWidth
                            type="password"
                            fieldProps={{ ...field }}
                            error={meta.touched && !lodash.isEmpty(meta.error)}
                            errorHelp={meta.error}
                          />
                        )}
                      </Field>
                    </div>
                  </div>

                  {/* CONFIRM PASSWORD ──────────────────────────────────────────────────────────────────────────────── */}
                  <div className="w-full flex">
                    <p className="w-1/3 text-base">Confirm password</p>
                    <div className="w-2/3">
                      <Field
                        name="confirmPassword"
                        validate={val => validateConfirmPassword(val, formikProps.values.password)}
                      >
                        {({ field, meta }) => (
                          <CustomInput
                            fullWidth
                            type="password"
                            fieldProps={{ ...field }}
                            error={meta.touched && !lodash.isEmpty(meta.error)}
                            errorHelp={meta.error}
                          />
                        )}
                      </Field>
                    </div>
                  </div>

                  {/* SIGNUP BUTTON ──────────────────────────────────────────────────────────────────────────────── */}
                  <div className="w-1/4 self-end">
                    <PrimaryButtton fullWidth type="submit">
                      Sign up
                    </PrimaryButtton>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
